import { MaskedLine, FadeUp, Eyebrow } from "@/components/Reveal";
import { Vine, FloatLeaf } from "@/components/Botanical";

const SECTIONS = [
  {
    n: "1",
    title: "Services",
    body: "We do not offer refunds on any service — whether completed, begun, or booked. Every service starts with a consultation, and if something about the result genuinely concerns you, tell us within 7 days and we will make it right with a complimentary correction where reasonable.",
  },
  {
    n: "2",
    title: "Memberships",
    body: "Membership fees are non-refundable once purchased. Benefits are valid for the recorded period, lapse on expiry, and cannot be encashed, carried forward or exchanged, as set out in the Membership Agreement.",
  },
  {
    n: "3",
    title: "The one exception",
    body: "If Salon Orgænics permanently ceases operations at this location and no alternative arrangement is offered, you will receive a pro-rata refund of the unused value of your active membership, calculated on the unexpired period. This is the only circumstance in which a refund is due.",
  },
  {
    n: "4",
    title: "Appointments & advances",
    body: "Booking advances follow our Terms & Conditions: if we cancel or cannot honour your slot, your advance for the unfulfilled appointment is refunded or carried to your next visit — your choice.",
  },
  {
    n: "5",
    title: "Retail products",
    body: "Sealed, unused retail products may be exchanged within 7 days with the bill. Opened or used products cannot be returned for hygiene reasons.",
  },
  {
    n: "6",
    title: "Raise a request",
    body: "Write to admin.saloneur@gmail.com or call +91 91580 00424 with your bill details. Genuine requests are answered within 7 working days.",
  },
];

export default function Refund() {
  return (
    <div data-testid="refund-page">
      <section className="relative bg-[#F9FAF8] overflow-hidden pt-36 pb-14">
        <Vine className="absolute left-8 top-24 h-[55%] w-auto opacity-30" />
        <FloatLeaf className="w-24 right-[16%] top-[24%] opacity-25" delay={0.4} />
        <div className="max-w-[1000px] mx-auto px-6 md:px-12 relative z-10">
          <MaskedLine onLoad className="mb-6">
            <Eyebrow>Fair, and in writing</Eyebrow>
          </MaskedLine>
          <h1 className="font-display font-light leading-[0.95] tracking-tight text-[#0A0A0A]">
            <MaskedLine onLoad delay={0.15} className="text-[11vw] md:text-7xl">
              <span>Refund <span className="italic text-[#11261A]">Policy</span></span>
            </MaskedLine>
          </h1>
          <FadeUp delay={0.35}>
            <p className="mt-6 text-base md:text-lg text-[#4A4A4A] max-w-xl leading-relaxed">
              The short version: no refunds on services or memberships — with one fair exception.
              If we ever close without an alternative, your unused membership value comes back
              pro-rata.
            </p>
          </FadeUp>
        </div>
      </section>

      <section className="bg-white py-14 md:py-20">
        <div className="max-w-[1000px] mx-auto px-6 md:px-12">
          <div className="space-y-10" data-testid="refund-sections">
            {SECTIONS.map((s) => (
              <FadeUp key={s.n}>
                <div className="grid md:grid-cols-12 gap-5 items-start border-t border-[#E5E7E3] pt-10">
                  <span className="md:col-span-2 font-display font-light text-4xl text-[#11261A]/20">{s.n}.</span>
                  <div className="md:col-span-10">
                    <h2 className="font-display font-light text-2xl md:text-3xl tracking-tight text-[#0A0A0A]">{s.title}</h2>
                    <p className="mt-4 text-sm md:text-base text-[#4A4A4A] leading-relaxed">{s.body}</p>
                  </div>
                </div>
              </FadeUp>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
